// Spec — a labelled cell for variant matrices: the live component above, the
// prop literal that produced it below. Keeps every "here are all the values of
// this union" block readable without repeating the markup in each section.

import type { ReactNode } from 'react';

interface SpecProps {
  /** The prop literal this cell demonstrates, e.g. `variant='danger'`. */
  label: string;
  children: ReactNode;
}

const Spec = ({ label, children }: SpecProps) => (
  <div className='theme-page__variant-cell'>
    <div className='theme-page__variant-demo'>{children}</div>
    <code className='theme-page__token-value'>{label}</code>
  </div>
);

export default Spec;
